module.exports = __webpack_public_path__ + "img/nginxStatic.fefc48ff.png";